(function ($, root, undefined) {
	
    $(function () {
      
      'use strict';

	
		/* -_-_-_-_-_-_-_-_-Modernizor Functions-_-_-_-_-_-_-_-_-_- */
		/* 
		   These basically allow you write javascript for different media quereies.
		   So, if I wanted to only perform a particular javascript function on 
		   mobile devices for example, I could do that within each "if statement.
		*/
	 
	 
		function mediaSize() { 

			if (window.matchMedia('(min-width: 1021px)').matches) {	 
				
				//parallax
				
					$(window).scroll(function(){

						var wScroll = $(this).scrollTop();

						// console.log(wScroll)

						$('.parallax-front').css({
							'transform': 'translate(0px, -'+ wScroll /50 + '%)'
						})

						$('.parallax-behind').css({
							'transform': 'translate(0px, '+ wScroll /25 + '%)'
						})    

						$('.secondary .parallax-front').css({
							'transform': 'translate(0px, -'+ wScroll /50 + '%)'
						})

						$('.secondary .parallax-behind').css({
							'transform': 'translate(0px, '+ wScroll /55 + '%)'
						})    


						})		

							
			} else {
				
				// console.log('small');
								
			}			
			
	
			
		}					
	
			
			/* Call the Modernizor function */
		  mediaSize();
		  /* Attach the function to the resize event listener */
			window.addEventListener('resize', mediaSize, false);  

          
      });
    
        
  })(jQuery, this);